import { jsx as _jsx } from "react/jsx-runtime";
import { ElementRenderer, generateElementKey } from '../ElementRenderer.js';
import { getLayoutStyles } from '../layout.js';
export function Box({ element }) {
    const layoutStyles = getLayoutStyles(element);
    return (_jsx("div", { className: "box-border", style: layoutStyles, children: element.children.map((child, index) => (_jsx(ElementRenderer, { node: child }, generateElementKey(child, index)))) }));
}
//# sourceMappingURL=Box.js.map